import { createFileRoute } from "@tanstack/react-router";
import { parseAuthSearch } from "./login";

/** `/forgot` — see `routes/login.tsx`; rendered by `__root.tsx`'s auth branch. */
export const Route = createFileRoute("/forgot")({
  validateSearch: parseAuthSearch,
  component: () => null,
});
